

<template>
<div>
<v-container>
<v-row>
<v-col cols="12" sm="12" lg="12">
   <proveedor></proveedor>
</v-col>
</v-row>   
</v-container>
   
</div>
</template>

<script>

import proveedor from '@/components/tienda/proveedor/Proveedor.vue';



export default {
    data () {
    return {
              
    }
  },
  components: {
    
    proveedor
    
  },

  methods: {

}

}
    

</script>


